(function () {
  var configs = {
    'TALLAS Y AJUSTE': {
      label: 'Tallas y ajuste',
      icon: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="4" y="5" width="16" height="14" rx="3"></rect><path d="M8 9h8M8 13h2m2 0h2m2 0h1"></path></svg>'
    },
    'ENVÍO GRATIS': {
      label: 'Envío gratis',
      icon: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h11v10H3zM14 9h3l4 4v3h-7z"></path><circle cx="7" cy="18" r="1.5"></circle><circle cx="18" cy="18" r="1.5"></circle></svg>'
    },
    'GARANTÍA DE DEVOLUCIÓN DE 30 DÍAS': {
      label: 'Garantía de devolución de 30 días',
      icon: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M9 7 5 11l4 4"></path><path d="M5 11h8a6 6 0 0 1 6 6"></path></svg>'
    }
  };

  function normalize(value) {
    return (value || '').replace(/\s+/g, ' ').trim().toUpperCase();
  }

  function replaceHeadingText(trigger, key, replacement) {
    var walker = document.createTreeWalker(trigger, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      if (normalize(node.nodeValue).indexOf(key) !== -1) {
        node.nodeValue = node.nodeValue.replace(/\S(?:.*\S)?/, replacement);
        return;
      }
    }
  }

  function enhanceAccordions() {
    document.querySelectorAll('.product-info__block--accordion').forEach(function (block) {
      if (block.classList.contains('sev-accordion--styled')) return;

      var trigger = block.querySelector('.product-info__accordion-trigger');
      if (!trigger) return;

      var triggerText = normalize(trigger.textContent);
      var key = Object.keys(configs).find(function (candidate) {
        return triggerText.indexOf(candidate) !== -1;
      });
      if (!key) return;

      var config = configs[key];
      block.classList.add('sev-accordion--styled');
      trigger.classList.add('sev-accordion-trigger');
      replaceHeadingText(trigger, key, config.label);

      if (!trigger.querySelector('.sev-accordion-icon')) {
        var icon = document.createElement('span');
        icon.className = 'sev-accordion-icon';
        icon.setAttribute('aria-hidden', 'true');
        icon.innerHTML = config.icon;
        trigger.insertBefore(icon, trigger.firstChild);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceAccordions);
  } else {
    enhanceAccordions();
  }

  document.addEventListener('shopify:section:load', enhanceAccordions);
})();
